import { Pulse } from '../elements/pulse.element';
import { Text } from '../elements/text.element';

export const SystemStatus = ({ isOnline, label, version }) => (
  <div className="flex items-center gap-6">
    <div className="flex items-center gap-2">
      <Pulse color={isOnline ? 'bg-green-500' : 'bg-red-500'} />
      {/* No `tracking-tight` here. The `label` role is 11px uppercase and sets
          `tracking-[0.18em]` on purpose — capitals have no ascender/descender
          rhythm to separate them, so they need POSITIVE tracking. This call
          site asked for negative, and once mergeClasses made the call site
          actually win its own group (see utils/classes.js) the footer computed
          to -0.275px: the app's status line was its least legible text. */}
      <Text variant="label">{label}</Text>
    </div>
    <div className="h-4 w-px bg-gray-200 hidden md:block"></div>
    <Text variant="mono" className="text-[10px] text-gray-300 hidden md:block">{version}</Text>
  </div>
);